<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="sec-7"><br/><br/><br/><br/><br/><br/>
<p class="center" id="pz7-1" style="margin-left: 3em; margin-right: 3em;">
<i>For Stuart Who walked beside me on my journey as a woman in the Churches of Christ
					and helped me find my voice.</i> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1dccb872